import type { ICellRendererParams } from "ag-grid-community";
import type { MouseEvent } from "react";

import type { TraceGridRow } from "./types";

import { InputVariablesPopover } from "@/components/ui/InputVariablesPopover";
import { Skeleton } from "@/components/ui/skeleton";

const stopCellNavigation = (event: MouseEvent) => {
  event.stopPropagation();
};

export const TraceInputVariablesCellRenderer = ({ data }: ICellRendererParams<TraceGridRow>) => {
  if (!data) {
    return null;
  }

  if (data.entity_hydration_status === "pending") {
    return (
      <div className="px-2 py-1">
        <Skeleton width="88px" height="32px" borderRadius="6px" />
      </div>
    );
  }

  const value = data.input_variables;
  if (!value || Object.keys(value).length === 0) {
    return <span className="text-gray-400">—</span>;
  }

  return <InputVariablesPopover variables={value} onTriggerClick={stopCellNavigation} />;
};
